export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5127.a0acf1fa.jpg";